import { useEffect, useState } from "react"
import { useLocation, useHistory, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { addMovies, fistToAddMovie, getMovieById, updateMovie } from "../store/actions/moviesActions"

export default function FormMovies(props) {
  const dispatch = useDispatch()
  const history = useHistory()

  const [newMovies, setNewMovies] = useState({
    id: props.movie ? props.movie.id : '',
    title:  props.movie ? props.movie.title : '',
    synopsis:  props.movie ? props.movie.synopsis : '',
    imgUrl:  props.movie ? props.movie.imgUrl : '',
    rating:  props.movie ? props.movie.rating : '',
    genreId:  props.movie ? props.movie.GenreId : '',
    trailerUrl:  props.movie ? props.movie.trailerUrl : '',
    price: props.movie ? props.movie.price : '',
    quantity:  props.movie ? props.movie.quantity : ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (props.state) {
      dispatch(updateMovie(newMovies))
      history.push('/')
      window.location.reload()
    } 
    else {
      dispatch(addMovies(newMovies))
      setNewMovies({
        id: '',
        title: '',
        synopsis: '',
        imgUrl: '',
        rating: '',
        genreId: '',
        trailerUrl: '',
        price: '',
        quantity: ''
      })
      history.push('/')
      window.location.reload()
      }
    }

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setNewMovies({...newMovies, [name]: value})
  }

  return (
    <>
      <div className="container">
      {props.state ? 
      <h3 className="card-title">Update Movie</h3>
        :
      <h3 className="card-title">Create New Movie</h3>
      }
      <div className="card-header ml-auto mr-auto">
        <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="row">
          </div>
          <div className="row">
            <div className="col-md-6 ml-auto mr-auto">
              <div className="form-group">
                <h6 className="card-title">Title</h6>
                <input type="title" className="form-control" name="title" value={newMovies.title} placeholder="Name Movie" onChange={e => handleOnChange(e)} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 ml-auto mr-auto">
              <div className="form-group">
                <h6 className="card-title">Synopsis</h6>
                <textarea className="form-control textarea" name="synopsis" value={newMovies.synopsis} placeholder="Description Movie" onChange={e => handleOnChange(e)}></textarea>
              </div>
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Image Url</h6>
              <input type="text" className="form-control" name="imgUrl" value={newMovies.imgUrl} placeholder="Enter Image Url" onChange={e => handleOnChange(e)} />
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Trailer Url</h6>
              <input type="text" className="form-control" name="trailerUrl" value={newMovies.trailerUrl} placeholder="Enter Trailer Url" onChange={e => handleOnChange(e)} />
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Price</h6>
              <input type="number" className="form-control" name="price" value={newMovies.price} placeholder="price" onChange={e => handleOnChange(e)} />
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Quantity</h6>
              <input type="number" className="form-control" name="quantity" value={newMovies.quantity} placeholder="Quantity movie" onChange={e => handleOnChange(e)} />
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Rating</h6>
              <input type="number" className="form-control" name="rating" value={newMovies.rating} placeholder="Rating Film" onChange={e => handleOnChange(e)} />
            </div>
          </div>
          <div className="col-md-6 ml-auto mr-auto">
            <div className="form-group">
              <h6 className="card-title">Genre Id</h6>
              <input type="number" className="form-control" name="genreId" value={newMovies.genreId} placeholder="Enter Gnere Id" onChange={e => handleOnChange(e)} />
            </div>
          </div>
            {props.state ? <div className="update col-md-6 ml-auto mr-auto">
              <button type="submit" className="btn btn-primary btn-round">Update Movie</button>
            </div> 
            :
            <div className="update col-md-6 ml-auto mr-auto">
              <button type="submit" className="btn btn-primary btn-round">Add Movie</button>
            </div>
            }
          </form>
        </div>
      </div>
    </div>
    </>
  )
}